const AIRPLAY_EVENT_NAME = 'mediaairplayrequest';
const AIRPLAY_ATTR = 'mediaisairplaying';
const AIRPLAY_UNAVAIL_ATTR = 'mediaairplayunavailable';

const CHROMECAST_EVENT_NAME = 'mediaentercastrequest';
const CHROMECAST_EXIT_EVENT = 'mediaexitcastrequest';
const CHROMECAST_ATTR = 'mediaiscasting';
const CHROMECAST_UNAVAIL_ATTR = 'mediacastunavailable';

const CC_TOGGLE_EVENT_NAME = 'mediatogglesubtitlesrequest';
const CC_ATTR = 'mediasubtitlesshowing';

export {
  AIRPLAY_ATTR,
  AIRPLAY_EVENT_NAME,
  AIRPLAY_UNAVAIL_ATTR,
  CHROMECAST_ATTR,
  CHROMECAST_EVENT_NAME,
  CHROMECAST_EXIT_EVENT,
  CHROMECAST_UNAVAIL_ATTR,
  CC_ATTR,
  CC_TOGGLE_EVENT_NAME,
};
